import { ReactElement, useState } from 'react';
import clsx from 'clsx';

interface AccordionProps {
    content: string | ReactElement;
}

const SimpleAccordion = ({ content }: AccordionProps) => {
    const [open, setOpen] = useState(false);

    return (
        <div className="w-full mb-4">
            <input
                id="expandCollapse"
                checked={open}
                type="checkbox"
                className="peer sr-only"
                readOnly
            />
            <label
                htmlFor="expandCollapse"
                className={clsx(
                    'w-full',
                    'flex',
                    'justify-center',
                    'items-center',
                    'bg-[#A3C159]',
                    'text-white',
                    'p-2',
                    'cursor-pointer',
                    'transition-colors',
                    'duration-500',
                    'ease-in-out',
                    'text-balance',
                    'text-center'
                )}
                onClick={() => setOpen(!open)}
            >
                Please click here for information regarding documents you will
                need to bring{' '}
                <span className="text-3xl font-bold ml-2">
                    {open ? '↑' : '↓'}
                </span>
            </label>
            <div
                className={clsx(
                    'overflow-hidden h-0',
                    'peer-checked:h-auto peer-checked:overflow-auto',
                    'transition-[height] duration-500 ease-in-out',
                    'overflow-auto'
                )}
            >
                <div className="text-black">{content}</div>
            </div>
        </div>
    );
};

export default SimpleAccordion;
